module.exports = __webpack_public_path__ + "static/img/driver.bb1f0cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/driver.png
// module id = 1S1t
// module chunks = 0